import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const servicebookPresentService = {
    getAllservicebookPresents,
    getservicebookPresent,
    updateservicebookPresent,
    createservicebookPresent,
    updateservicebookPresentStatus
};

const MODULE = {
    PRESNET: 'service-book-presents',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllservicebookPresents(filter) {
    const requestOptions = {
      params: {
        page: filter.pageNumber,
        size: filter.pageSize,
        is_locked: filter.isLocked,
        is_active: filter.isActive, 
      }
    }
    
    let array = filter.searchArray
    array.forEach((word, index) => {
      if(word != null || word != '')
      {
        var searchParam = `search_words[${index}]`
        requestOptions.params[searchParam] = word
      }
    })
  
    return apiHelper(API_URL).get(`/${MODULE.PRESNET}`, requestOptions)
  }

  export function getservicebookPresent(id) {   
    return apiHelper(API_URL).get(`/${MODULE.PRESNET}/${id}`)
  }

  export function updateservicebookPresent(data) {
    const requestOptions = {
      name: data.name,
    }
  
    return apiHelper(API_URL).put(`/${MODULE.PRESNET}/${data.id}`, requestOptions)
  }

  export function createservicebookPresent(data) {
    const requestOptions = {
      name: data.name,
    }
  
    return apiHelper(API_URL).post(`/${MODULE.PRESNET}`, requestOptions)
  }

  export function updateservicebookPresentStatus(data) {
    const requestOptions = {
      is_active: data.isActive
    }
    
    return apiHelper(API_URL).patch(`/${MODULE.PRESNET}/${data.id}`, requestOptions)
    
  }